import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d16e87c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "part-collections-toolbar is-flex is-justify-content-space-between mb-3" }
const _hoisted_2 = { class: "is-flex" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "control has-icons-left is-pulled-right half-width search-control" }
const _hoisted_6 = ["value", "placeholder"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon is-left fas fa-search" }, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "search-right-meta"
}
const _hoisted_9 = { class: "search-results-count has-text-grey" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["id"]

import { computed, onBeforeUnmount, ref, watch } from 'vue'
import PartCollectionBlock from './PartCollectionBlock.vue'
import BomAddToCartModal from '@/components/library/content/asset/viewer/illustrationViewer/bom/BomAddToCartModal.vue'
import TwoDModal from '@/components/library/content/TwoDModal.vue'
import { getPart } from '@/controllers/library/part'
import { useComposableForEsc } from '@/components/common/modal/useComposableForEsc'

import type { DisplayCollection, PartRow } from '@/interfaces/library/partCollection'


export default /*#__PURE__*/_defineComponent({
  __name: 'PartCollectionsLayout',
  props: {
    ownerId: {},
    search: {},
    searchResultsCount: {},
    isSearching: { type: Boolean },
    isSearchMode: { type: Boolean },
    isExpandingAll: { type: Boolean },
    collections: {},
    columnWidths: {},
    contentWidth: {},
    effectivePartColumns: {},
    isCartOrErpCartEnabled: { type: Boolean },
    addToCartModalOpen: { type: Boolean },
    cartItem: {},
    isWidgetCartEnabled: { type: Boolean },
    hasHidePrice: { type: Boolean },
    hasAnExpandedCollection: { type: Boolean },
    isWidget: { type: Boolean },
    getExpanded: { type: Function }
  },
  emits: ["expand-all", "collapse-all", "search-input", "clear-search", "scroll", "toggle-collection", "add-to-cart", "add-all-to-cart", "export-parts", "cart-submit", "close-cart-modal", "toggle-show-retail-price", "toggle-show-wholesale-price", "toggle-show-discount-price"],
  setup(__props: any, { expose: __expose }) {

const props = __props



const scrollContainer = ref<HTMLElement | null>(null)
const partThumbnailPreview = ref<{ filepath: string, title: string } | null>(null)
let previewRequestId = 0

function getPreviewTitle(part: PartRow): string {
  return part.partNumber
    ? `${part.name} (${part.partNumber})`
    : part.name
}

function toAbsoluteUrl(filepath: string): string {
  return new URL(filepath, window.location.origin).href
}

async function openPartThumbnailPreview(part: PartRow) {
  if (!part.thumbnailUrl) return

  const requestId = ++previewRequestId

  try {
    const partDetails = part.thumbnailUrlLarge
      ? part
      : await getPart(part.id)

    if (requestId !== previewRequestId || !partDetails.thumbnailUrlLarge) return

    partThumbnailPreview.value = {
      filepath: toAbsoluteUrl(partDetails.thumbnailUrlLarge),
      title: getPreviewTitle(part)
    }
  } catch {
    // Keep the compact Part Collections view unchanged if preview data cannot be loaded.
  }
}

function closePartThumbnailPreview() {
  previewRequestId++
  partThumbnailPreview.value = null
}

watch(() => props.ownerId, closePartThumbnailPreview)

onBeforeUnmount(() => {
  previewRequestId++
})

useComposableForEsc({
  dismissFunction: closePartThumbnailPreview,
  isActive: computed(() => partThumbnailPreview.value !== null)
})

__expose({
  get scrollRef() {
    return scrollContainer.value ?? null
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["part-collections-card mx-1", {'expanded-part-collections-card': _ctx.hasAnExpandedCollection}])
  }, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("article", _hoisted_2, [
        _createElementVNode("button", {
          disabled: _ctx.isExpandingAll || _ctx.isSearchMode,
          class: "button mr-2",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('expand-all')))
        }, _toDisplayString(_ctx.$t('expandAll')), 9, _hoisted_3),
        _createElementVNode("button", {
          disabled: _ctx.isExpandingAll || _ctx.isSearchMode,
          class: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('collapse-all')))
        }, _toDisplayString(_ctx.$t('collapseAll')), 9, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("input", {
          value: _ctx.search,
          placeholder: `${_ctx.$t('searchContent', { content: _ctx.$tc('part', 2) })}...`,
          type: "text",
          class: "input search-input",
          onInput: _cache[2] || (_cache[2] = event => _ctx.$emit('search-input', event))
        }, null, 40, _hoisted_6),
        _hoisted_7,
        (_ctx.search)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.searchResultsCount) + " " + _toDisplayString(_ctx.$tc('result', _ctx.searchResultsCount)), 1),
              _createElementVNode("button", {
                type: "button",
                class: "search-clear-button",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('clear-search')))
              }, _hoisted_11)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("section", {
      ref_key: "scrollContainer",
      ref: scrollContainer,
      class: "part-collections-list-region pb-2",
      onScroll: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('scroll', $event)))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collections, (collection) => {
        return (_openBlock(), _createElementBlock("div", {
          id: `part-collection-${collection.id}`,
          key: collection.rowKey
        }, [
          _createVNode(PartCollectionBlock, {
            "can-add-all-to-cart": _ctx.isWidget ? _ctx.isWidgetCartEnabled : _ctx.isCartOrErpCartEnabled,
            collection: collection,
            "column-widths": _ctx.columnWidths,
            "content-width": _ctx.contentWidth,
            expanded: _ctx.getExpanded(collection),
            "is-expanding-all": _ctx.isExpandingAll,
            "is-search-mode": _ctx.isSearchMode,
            "is-searching": _ctx.isSearching,
            "part-columns": _ctx.effectivePartColumns,
            "has-hide-price": _ctx.hasHidePrice,
            "is-widget": _ctx.isWidget,
            onAddToCart: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('add-to-cart', $event))),
            onAddAllToCart: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('add-all-to-cart', $event))),
            onExportParts: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('export-parts', $event))),
            onToggle: ($event: any) => (_ctx.$emit('toggle-collection', collection.id)),
            onToggleShowRetailPrice: ($event: any) => (_ctx.$emit('toggle-show-retail-price', collection.id)),
            onToggleShowWholesalePrice: ($event: any) => (_ctx.$emit('toggle-show-wholesale-price', collection.id)),
            onToggleShowDiscountPrice: ($event: any) => (_ctx.$emit('toggle-show-discount-price', collection.id)),
            onPreviewThumbnail: openPartThumbnailPreview
          }, null, 8, ["can-add-all-to-cart", "collection", "column-widths", "content-width", "expanded", "is-expanding-all", "is-search-mode", "is-searching", "part-columns", "has-hide-price", "is-widget", "onToggle", "onToggleShowRetailPrice", "onToggleShowWholesalePrice", "onToggleShowDiscountPrice"])
        ], 8, _hoisted_12))
      }), 128))
    ], 544),
    (_ctx.addToCartModalOpen && !!_ctx.cartItem)
      ? (_openBlock(), _createBlock(BomAddToCartModal, {
          key: 0,
          "bom-item": _ctx.cartItem,
          "is-widget-cart-enabled": _ctx.isWidgetCartEnabled,
          onAddToCart: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('cart-submit', $event))),
          onCancel: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('close-cart-modal'))),
          onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('close-cart-modal')))
        }, null, 8, ["bom-item", "is-widget-cart-enabled"]))
      : _createCommentVNode("", true),
    (partThumbnailPreview.value)
      ? (_openBlock(), _createBlock(TwoDModal, {
          key: 1,
          "data-unit": "part-collection-thumbnail-modal",
          filepath: partThumbnailPreview.value.filepath,
          title: partThumbnailPreview.value.title,
          onClose: closePartThumbnailPreview
        }, null, 8, ["filepath", "title"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})